var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("collapsible-card", {
    ref: "collapseCustomFields",
    attrs: {
      "collapse-id": "custom-fields-card",
      "store-path": "customFields",
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function (ref) {
          var collapsed = ref.collapsed
          return [
            _c("span", { staticClass: "mr-2" }, [
              _vm._v(_vm._s(_vm.$t("global.doorr.additionalFields"))),
            ]),
            _vm._v(" "),
            !collapsed
              ? _c(
                  "div",
                  { staticClass: "coapp-actions d-flex align-items-center" },
                  [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip",
                            value: {
                              title: _vm.$t(
                                "custom-fields.actions.customizeFields"
                              ),
                              placement: "top",
                            },
                            expression:
                              "{\n          title: $t('custom-fields.actions.customizeFields'),\n          placement: 'top'\n        }",
                          },
                        ],
                        staticClass: "clickable mr-2",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-cog",
                          attrs: { "aria-hidden": "true" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleEditing()
                            },
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip",
                            value: {
                              title: _vm.$t(
                                "custom-fields.actions.addCustomField"
                              ),
                              placement: "top",
                            },
                            expression:
                              "{\n          title: $t('custom-fields.actions.addCustomField'),\n          placement: 'top'\n        }",
                          },
                        ],
                        staticClass: "clickable",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-plus text-primary",
                          attrs: { "aria-hidden": "true" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleCreating()
                            },
                          },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.loading
              ? _c("referrer-custom-fields-loader")
              : [
                  _vm.showCustomDataFieldsForm
                    ? _c("custom-data-fields-form", {
                        attrs: {
                          value: _vm.customFields,
                          "page-name": "referrers",
                          "custom-fields-definitions": _vm.definitionsById,
                        },
                        on: { change: _vm.handleCustomFieldDataChange },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _vm.creating
                        ? _c("create-custom-field-form", {
                            ref: "createCustomFieldForm",
                            on: {
                              hide: function ($event) {
                                return _vm.toggleCreating(false)
                              },
                              submit: function (value) {
                                return _vm.handleFieldChange(value, "create")
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.editing && !_vm.currentEditingField
                    ? _c("edit-fields-definitions-form", {
                        attrs: {
                          "custom-fields": _vm.customFields,
                          "custom-fields-definitions":
                            _vm.customFieldsDefinitions,
                          "page-name": "referrers",
                          "allow-visibility": false,
                        },
                        on: {
                          create: function ($event) {
                            return _vm.toggleCreating(true)
                          },
                          edit: _vm.toggleEditField,
                          cancel: function ($event) {
                            return _vm.toggleEditing(false)
                          },
                          delete: _vm.handleDelete,
                          order: _vm.handleOrder,
                          visibility: _vm.handleVisibilityToggle,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentEditingField
                    ? _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c("create-custom-field-form", {
                            ref: "createCustomFieldForm",
                            attrs: { value: _vm.currentEditingField },
                            on: {
                              hide: function ($event) {
                                return _vm.toggleEditField(null)
                              },
                              submit: function (value) {
                                return _vm.handleFieldChange(value, "update")
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }